import axiosInstance from "../../Interceptors/axiosInstance.jsx";

const getResult = (response) => {
  const payload = response.data;

  if (!payload?.isSuccess) {
    throw new Error(payload?.message || "Unable to complete the career request.");
  }

  return payload.result;
};

export const getAllCareers = async () => {
  const response = await axiosInstance.get("career/getall");
  return getResult(response);
};

export const getCareerById = async (id) => {
  const response = await axiosInstance.get(`career/get/${id}`);
  return getResult(response);
};

export const addCareer = async (payload) => {
  const response = await axiosInstance.post("career/add", payload);
  return getResult(response);
};

export const updateCareer = async (payload) => {
  const response = await axiosInstance.put("career/update", payload);
  return getResult(response);
};

export const deleteCareer = async (id) => {
  const response = await axiosInstance.delete(`career/delete/${id}`);
  return getResult(response);
};

export const updateCareerStatus = async (id, status) => {
  const response = await axiosInstance.put("career/status", {
    id: Number(id),
    status,
  });
  return getResult(response);
};
